export enum ImageFormat {
  PDF = 'pdf',
  JPG = 'jpg'
}
